export default __webpack_public_path__ + "static/media/Avatar-12-noback.eb8bad62.png";